import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
  Renderer2,
} from '@angular/core';
import { map } from 'rxjs/operators';

import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';
import { CURRENCY_FORMAT_DECIMALS } from '@rx-applications/clientsite/shared/currency/data-access';
import { PaymentSummaryCommissionModel } from '@app/layout-app/shared';
import {
  TRANSLATION_SCOPE,
  translationProvider as SummaryPanelRoomFloatingTranslations,
} from './assets/i18n/translation.provider';
import { PaymentSummaryRoomModel } from '@rx-applications/clientsite/shared/utils';

@Component({
  selector: 'rx-summary-panel-room-floating',
  templateUrl: './summary-panel-room-floating.component.html',
  styleUrls: ['./summary-panel-room-floating.component.scss'],
  providers: [SummaryPanelRoomFloatingTranslations],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryPanelRoomFloatingComponent implements OnDestroy {
  @Input() showButton: boolean;
  @Input() disableButton: boolean;
  @Input() hotelId: number;
  @Input() hotelName: string;
  @Input() thumbnailUrl?: string;
  @Input() rooms: PaymentSummaryRoomModel[];
  @Input() checkInDate: string;
  @Input() checkOutDate: string;
  @Input() totalPrice: number;
  @Input() commission: PaymentSummaryCommissionModel;
  @Input() adultsAmount?: number;
  @Input() paymentType?: string;
  @Input() shadedTotal = false;
  @Input() saverPlusFee?: number;
  @Input() modalLayout = false;

  @Output() clickButton = new EventEmitter();

  readonly #configFacade = inject(ConfigFacade);
  readonly formatDecimals = CURRENCY_FORMAT_DECIMALS;
  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  constructor(private renderer: Renderer2) {
    this.renderer.addClass(document.body, 'mobile');
  }

  get currency$() {
    return this.#configFacade.selectedCurrency$.pipe(map((currency) => currency || 'EUR'));
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'mobile');
  }
}
